/**
 * Validates a value is a UUID.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name uuid
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }

  return Promise.resolve(/^[a-f\d]{8}(-[a-f\d]{4}){4}[a-f\d]{8}$/i.test(value) ? null : 'not-a-uuid');
}

module.exports = validate;